/* eslint-disable @nx/enforce-module-boundaries */
import { Tag, TagCloseButton, TagLabel } from '@mybridge/ui';
import { HStack } from '@mybridge/ui/layout';
import { useEffect, useMemo, useState } from 'react';
import { useIndustry } from 'v4/lib/hooks/use-industry';
import { CityStateCountryDropdown } from '../city-state-country-dropdown';
import { formatLocation } from 'v4/lib/commons';

export const LocationTagsInput = ({
  value,
  defaultValue,
  onChange,
  keyName = 'name',
  ...props
}) => {
  const [selected, setSelected] = useState(defaultValue ?? []);

  useEffect(() => {
    if (
      Array.isArray(value) &&
      JSON.stringify(value) !== JSON.stringify(selected)
    ) {
      setSelected(value);
    }
  }, [value]);

  const handleChange = (val) => {
    const sel = [...(selected ?? [])];
    if (!sel.find((s) => formatLocation(s) === formatLocation(val))) {
      sel?.push(val);
      onChange_([...(sel ?? [])]);
    }
  };

  const handleRemove = (val) => (e) => {
    const sel = selected?.filter?.(
      (s) => formatLocation(s) !== formatLocation(val)
    );
    onChange_([...(sel ?? [])]);
  };

  const onChange_ = (val) => {
    // console.log('location Info', val);
    setSelected(val);
    onChange?.(val);
  };

  return (
    <>
      <CityStateCountryDropdown
        // <IndustryDropdown
        onChange={handleChange}
        value={value}
        defaultValue={defaultValue}
        clearOnSelect={true}
        noIcon
        {...props}
      />
      {selected?.length ? (
        <HStack mt={4} flexWrap="wrap">
          {/* {selected?.map?.((item, itemIndex) => ( */}
          {selected?.map?.((item, itemIndex) => (
            <Tag p={2} borderRadius={'full'} key={itemIndex}>
              <TagLabel pl={2}>{formatLocation(item)}</TagLabel>
              <TagCloseButton pr={2} onClick={handleRemove(item)} />
            </Tag>
          ))}
        </HStack>
      ) : (
        ''
      )}
    </>
  );
};
